import React from "react";
import { useAuth } from "../context/AuthContext";
import { Box, Typography, CircularProgress } from "@mui/material";

const AdminGuard = ({ children, fallback = null }) => {
    const { currentUser, isAdmin, loading } = useAuth();

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!currentUser || !isAdmin) {
        return fallback || (
            <Box sx={{ p: 3, textAlign: "center" }}>
                <Typography variant="h5" color="error" gutterBottom>
                    Acceso Denegado
                </Typography>
                <Typography variant="body1">
                    Esta sección es solo para administradores.
                </Typography>
            </Box>
        );
    }

    return children;
};

export default AdminGuard; 